Um zu dem passenden Formular zu navigieren, geben Sie bitte die LeadSourceId Ihrer Firma ein:<br/>
<mat-form-field appearance="fill">
  <mat-label>LeadSourceId</mat-label>
  <input matInput [(ngModel)]="leadSourceId" />
</mat-form-field>
<br/>
<button mat-raised-button color="primary" [routerLink]="['/lead-sources/' + leadSourceId + '/transition']">Überleitungs-Formular öffnen</button>

<!--TODO: open generic lead form, for some (in config hard coded) lead source ids, open a specific component-->
